import Icon from "../common/Icon";
import Logo from "../common/Logo";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPublicSettings } from "../../services/contentService";

export default function Footer() {
  const [contact, setContact] = useState({
    whatsapp: "https://wa.me/918320342657",
    instagram: "https://www.instagram.com/trishul_travels_gj15",
    instagram_secondary: "https://www.instagram.com/7639_ertiga",
    google: "https://share.google/DQD5kUd68h0zLJ6MA",
  });
  useEffect(() => {
    const fetchContact = () => {
      getPublicSettings("contact").then(({ data }) => {
        if (data) setContact((current) => ({ ...current, ...data }));
      });
    };
    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      window.requestIdleCallback(fetchContact, { timeout: 3500 });
    } else {
      setTimeout(fetchContact, 2500);
    }
  }, []);
  return (
    <footer>
      <div className="container">
        <div className="foot-grid">
          <div className="foot-brand">
            <Logo variant="footer" />
            <p>
              Reliable, comfortable and hassle-free vehicle rental services for
              every journey — across Vapi, Daman, Silvassa, Sarigam, Umbergaon,
              Surat, Mumbai and all over India.
            </p>
          </div>

          <div>
            <p className="foot-heading">Explore</p>
            <div className="foot-explore-cols">
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/fleet">Fleet</Link>
                </li>
              </ul>
              <ul>
                <li>
                  <Link to="/booking">Booking</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                <li>
                  <Link to="/faqs">FAQs</Link>
                </li>
                <li>
                  <Link to="/routes">Taxi Routes</Link>
                </li>
              </ul>
            </div>
          </div>


          <div>
            <p className="foot-heading">Get In Touch</p>
            <ul>
              <li>
                <a href="tel:+918320342657">+91 83203 42657</a>
              </li>
              <li>
                <a href="mailto:trishultoursandtravels2315@gmail.com">
                  trishultoursandtravels2315@gmail.com
                </a>
              </li>
              <li style={{ marginTop: 4, lineHeight: 1.45, fontSize: ".82rem", color: "var(--muted-lt)" }}>
                Shop No. 1, AB Automobiles, Opp. Bharat Petroleum, GIDC Bypass Road, Sarigam - 396155, Gujarat
              </li>
            </ul>
            <div className="foot-social" style={{ marginTop: 16 }}>
              <a href={contact.whatsapp} target="_blank" rel="noreferrer" title="WhatsApp">
                <Icon name="ic-whatsapp" size={16} />
              </a>
              <a href={contact.instagram} target="_blank" rel="noreferrer" title="Instagram">
                <Icon name="ic-instagram" size={16} />
              </a>
              <a
                href={contact.instagram_secondary}
                target="_blank"
                rel="noreferrer"
                title="Vehicle Profile"
              >
                <Icon name="ic-instagram" size={16} />
              </a>
              <a href={contact.google} target="_blank" rel="noreferrer" title="Google Reviews & Location">
                <Icon name="ic-google" size={16} />
              </a>
            </div>
          </div>
        </div>


        <div className="foot-bottom">
          <span>
            © <span>{new Date().getFullYear()}</span> Trishul Tours &amp;
            Travels. All rights reserved.
          </span>
          <span className="foot-credit">
            <span>Your Journey. Our Responsibility.</span>
            <a
              href="https://inspirationsoftsolutions.com/"
              target="_blank"
              rel="noreferrer"
            >
              Designed &amp; developed by Inspiration Soft Solutions
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
